<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <p-calendar
    dateFormat="yy-mm-dd"
    appendTo="body"
    [inputId]="id()"
    [ngModel]="value()"
    [placeholder]="placeholder()"
    [readonlyInput]="true"
    (onSelect)="updateValue($event)"
    (onBlur)="markAsTouched()" />
</ui-control-field>
